/**
 * @Description
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import Header from '../Header';
// import Footer from '../Footer';
import PPTTable from '../Table';
import PPTPieChart from '../PieChart';
import { isNotEmptyAny } from '@lhb/func';
import { PPTColor } from '../Table';

const PageFive:FC<any> = ({
  storeFormatVO,
  rangeName,
  centerCategoryVo,
  // qrCode
}) => {
  // const mendian = [
  //   { index: 1, commercial: '小吃快餐', percent: '35%', count: '100', color: '#358AFF' },
  //   { index: 2, commercial: '教育', percent: '35%', count: '85', color: '#FF8A8A' },
  //   { index: 3, commercial: '零售', percent: '25%', count: '78', color: '#A896EF' },
  //   { index: 4, commercial: '中餐', percent: '18%', count: '60', color: '#F2993D' },
  //   { index: 5, commercial: '娱乐', percent: '12%', count: '50', color: '#80D6EB' },
  // ];

  const title = useMemo(() => {
    if (!centerCategoryVo?.centerCategoryName) return '';
    return `${centerCategoryVo?.centerCategoryName}`;
  }, [centerCategoryVo]);

  return (
    <div className={styles['page']}>
      <Header title={`门店/${title}业态 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['side']}>
          <div className={styles['title']}>门店业态</div>

          <div className={styles['detail']}>
            {/* 本区域各业态门店共<span className={styles['detail-point']}> 300 </span>个，占比最高的是<span className={styles['detail-point']}>小吃快餐，占比 35%</span>，有<span className={styles['detail-point']}>100个门店</span>。 */}
            {storeFormatVO?.introduction || '-'}
          </div>

          <div className={styles['table']}>
            <PPTTable data={storeFormatVO?.fomatVOList}/>
          </div>

          <div className={styles['chart']}>
            <PPTPieChart
              title='门店业态'
              type='circle'
              height={220}
              seriesData={[{
                data: storeFormatVO?.fomatVOList?.map((item) => ({ name: item.commercialName, value: item.num })) || [],
                center: [110, '50%'],
                itemStyle: {
                  normal: {
                    color: (colors: any) => {
                      return PPTColor[colors.dataIndex + 1];
                    }
                  }
                }
              }]}
              config={{
                title: {
                  left: 55,
                },
                legend: {
                  width: '384px',
                  itemGap: 16,
                  left: '238px',
                },
              }}
            />
          </div>
        </div>

        <div className={styles['side']}>
          <div className={styles['title']}>{`${title}业态`}</div>

          <div className={styles['detail']}>
            {/* 本区域各业态门店共<span className={styles['detail-point']}> 300 </span>个，占比最高的是<span className={styles['detail-point']}>小吃快餐，占比 35%</span>，有<span className={styles['detail-point']}>100个门店</span>。 */}
            {centerCategoryVo?.introduction}
          </div>

          <div className={styles['table']} style={{ marginBottom: 34 }}>
            {(isNotEmptyAny(centerCategoryVo?.fomatVOList) && centerCategoryVo?.fomatVOList.length) ? <PPTTable data={centerCategoryVo?.fomatVOList}/> : <></>}
          </div>

          {title ? <div className={styles['chart']}>
            <PPTPieChart
              title={`${centerCategoryVo?.centerCategoryName}业态`}
              type='circle'
              height={220}
              seriesData={[{
                data: centerCategoryVo?.fomatVOList?.map((item) => ({ name: item.commercialName, value: item.num })) || [],
                center: [110, '50%'],
                itemStyle: {
                  normal: {
                    color: (colors: any) => {
                      return PPTColor[colors.dataIndex + 1];
                    }
                  }
                }
              }]}
              config={{
                title: {
                  left: 55,
                },
                legend: {
                  width: '384px',
                  itemGap: 16,
                  left: '238px',
                },
              }}
            />
          </div> : <></>}
        </div>
      </div>

      <div className={styles['footer']}>
        {/* <Footer qrCode={qrCode}/> */}
      </div>
    </div>
  );
};

export default PageFive;
